import { Card, CardContent, CircularProgress, Container, Table, TableBody, TableCell, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import KomponenList from 'examples/Lists/KomponenList'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { Route, Routes } from 'react-router-dom'
import userStore from 'store/userStore'
import Komponen from '../LaporanBelanja/Komponen'

const PaketDak = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="komponen" element={<Komponen />} />
        </Routes>
    )
}

const Data = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        reqProyekDak()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqProyekDak = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/komponen-belanja/dak',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta,

            },
            decryptedUser,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {decodedUser.kd_pd} {decodedUser.nm_pd}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {tahunAnggaran.ta}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>
            {/* <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={4} lg={4}>
                        <MiniStatisticsCard
                            bgColor='white'
                            title={{
                                text: "Total Paket DAK"
                            }}
                            count={data.length}
                            icon={{ color: "info", component: <AttachMoney /> }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <MiniStatisticsCard
                            title={{
                                text: "Paket DAK Fisik"
                            }}
                            count='3400000'
                            icon={{ color: "error", component: <People /> }}
                        // percentage={{ color: "error", text: ((totalRincian / data?.anggaran) * 100).toFixed(2) + '%' }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <MiniStatisticsCard
                            title={{
                                text: "Paket DAK Non Fisik"
                            }}
                            count='3400000'
                            icon={{ color: "error", component: <People /> }}
                        // percentage={{ color: "error", text: ((totalRincian / data?.anggaran) * 100).toFixed(2) + '%' }}
                        />
                    </Grid>
                </Grid>
            </ArgonBox> */}
            <Container>
                <ArgonBox px={2}>
                    <Card sx={{ p: 2 }}>
                        <ArgonTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                            Proyek DAK
                        </ArgonTypography>
                    </Card>
                </ArgonBox>
                {
                    loading ?
                        (
                            (
                                <ArgonBox align="center" mt={3}>
                                    <CircularProgress />
                                </ArgonBox>
                            )
                        )
                        :
                        (
                            <ArgonBox p={2}>
                                <KomponenList
                                    title="Proyek DAK"
                                    listData={data}
                                    to='/a-pd/paket-dak/komponen'
                                    showOpd={false}
                                />
                            </ArgonBox>
                        )
                }
            </Container>
        </ArgonBox>
    )
}

export default PaketDak